<template>
  <div>
    <a-row :gutter="30" style="padding-top:30px;">
      <a-col span="7" style="margin-bottom:25px;">
        <a-row type="flex" align="top">
          <a-col span="5" class="form-label">消息时间</a-col>
          <a-col span="18">
            <a-range-picker
              style="display:block;width:auto"
              format="YYYY-MM-DD"
              v-model="params.time"
            />
          </a-col>
        </a-row>
      </a-col>
      <a-col span="7" style="margin-bottom:25px;">
        <a-button
          type="primary"
          style="margin-right:12px;padding:0 30px;"
          @click="getData()"
          >查询</a-button
        >
      </a-col>
    </a-row>
    <div class="data-table" style="padding:30px 0;">
      <a-table
        :columns="columns"
        :dataSource="dataSource"
        rowKey="id"
        :pagination="pagination"
        :loading="loading"
        @change="getData"
      >
      </a-table>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import Api from "@/api";
export default {
  name: "Message",
  data() {
    return {
      loading: false,
      dataSource: [],
      columns: [],
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0,
        pageSizeOptions: ["10", "20", "50"],
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true,
        showSizeChanger: true
      },
      params: {
        time: []
      }
    };
  },
  computed: {},
  async created() {
    this.setColums();
    this.getData();
  },
  async mounted() {
    await Api.account.alreadyRead();
    this.$store.commit("setMessage", 0);
  },
  methods: {
    setColums() {
      this.columns = [
        {
          width: "80%",
          title: "消息内容",
          dataIndex: "summary"
        },
        {
          title: "操作者",
          dataIndex: "user"
          // sorter: true
        },
        {
          title: "操作时间",
          dataIndex: "time_created_format",
          key: "time_order",
          sorter: true
        }
      ];
    },
    async getData(pagination, filters, sorter) {
      this.loading = true;
      if (pagination) {
        let pager = { ...this.pagination };
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        this.pagination = pager;
      } else {
        this.pagination.current = 1;
      }

      let params = {
        created_start:
          this.params.time[0] &&
          this.params.time[0].format("YYYY-MM-DD HH:mm:ss"),
        created_end:
          this.params.time[1] &&
          this.params.time[1].format("YYYY-MM-DD HH:mm:ss"),
        page: this.pagination.current,
        limit: this.pagination.pageSize
      };
      if (sorter && sorter.columnKey) {
        params[sorter.columnKey] = sorter.order === "ascend" ? "asc" : "desc";
      }
      let response = await Api.account.messageList(params);
      this.loading = false;
      this.pagination.total = +response.total;
      this.dataSource = response.list;
    },
    resetParams() {
      let params = {
        time: []
      };
      this.params = { ...params };
    }
  }
};
</script>

<style scoped lang="scss"></style>
